import React from 'react';
import ModuleOperationsPage from './ModuleOperationsPage';

const P2pOperationsPage: React.FC = () => (
  <ModuleOperationsPage
    category="p2p"
    moduleKey="p2p"
    title="P2P Operations"
    description="P2P escrow money movements with the platform's collected fees and balance."
  />
);

export default P2pOperationsPage;
